import React from 'react';
import PropTypes from 'prop-types';
import {useNavigate} from "react-router-dom";
import {get} from 'lodash';

import ChallengeTile from 'common/ui/ChallengeTile';


function AStream({stream}) {
    const navigate = useNavigate();

    function onClick() {
        const is_pq = get(stream, 'lesson.challenge_version.challenge_code.is_pq');
        if (is_pq) {
            navigate(`/quiz/${stream.code}`);
        } else {
            navigate(`/hello/${stream.code}`);
        }
    }

    return (
        <div className="student-dashboard-a-stream">
            <ChallengeTile
                challenge_version={stream.lesson.challenge_version}
                show_kid={true}
                description={stream.lesson.code.toUpperCase()}
                button_label={`View`}
                buttonOnClick={onClick}
            />
        </div>
    )
}

AStream.propTypes = {
    stream: PropTypes.object.isRequired
}

export default AStream;
